<template>
  <v-container style="width: 98vmax; max-width: 2500px; position: relative;" class="justify-center pa-0">
    <v-progress-linear color="#006D94" height="4" indeterminate rounded v-if="loading"></v-progress-linear>

    <v-container class="ml-0 align-center" fluid style="width: 100%;">

      <v-alert class="mb-2" variant="outlined" type="error" border="top" v-if="error">
        Server Error: Could fetch resources.
      </v-alert>

      <iframe id='qlik_frame' style='border:none;width:100%;height:100%;'></iframe>

    </v-container>
  </v-container>
</template>

<script>
import axios from 'axios';
import enigma from 'enigma.js';
import config from '../config.js';

export default {
  data() {
    return {
      drawer: true,
      rail: true,
      loading: true,
      TENANT: 'hpc.eu.qlikcloud.com',//config.QLIK_TENANT,
      WEBINTEGRATIONID: 'ZhIuJAk61EHbKissqQplMdTio5mEZDND',//config.QLIK_WEBINTEGRATIONID,
      APPID: '3e088fdc-1c63-4334-810d-a00edc8f18ce',//config.QLIK_APPID_BI,
      SHEETID: 'f9d79074-ac54-479f-9b66-7374c31fb363',//config.QLIK_SHEETID_BI,
      error: false
    };
  },
  created() {
    document.title = 'TIS BI Dashboard'
    this.main();
  },
  methods: {
    logout() {
      localStorage.removeItem('token');
      this.$router.push('/login');
    },
    close() {
      this.$router.push('/');
    },


    async main() {
      this.error = false;
      console.debug("HERE :-)")
      axios.get(`${config.baseURL}/api/v1/qlik_jwt/`).then(response => {

        const token = response.data.token;

        console.log(token)

        const authHeader = `Bearer ${token}`;

        fetch(`https://${this.TENANT}/login/jwt-session?qlik-web-integration-id=${this.WEBINTEGRATIONID}`, {
          credentials: 'include',
          mode: 'cors',
          method: 'POST',
          headers: {
            'Authorization': authHeader,
            'qlik-web-integration-id': this.WEBINTEGRATIONID
          },
        })
          .then(response => {
            console.debug(response)


            fetch(`https://${this.TENANT}/api/v1/csrf-token`, {
              mode: 'cors',
              credentials: 'include',
              headers: {
                'Authorization': authHeader,
                'qlik-web-integration-id': this.WEBINTEGRATIONID
              },
            }).then(response => {

              console.debug(response)

              const csrfToken = new Map(response.headers).get('qlik-csrf-token');

              const qcsHeaders = { 'qlik-web-integration-id': this.WEBINTEGRATIONID, 'qlik-csrf-token': csrfToken }

              const params = Object.keys(qcsHeaders)
                .map((key) => `${key}=${qcsHeaders[key]}`)
                .join('&');

              console.debug(params)

              fetch('https://unpkg.com/enigma.js@2.7.0/schemas/12.612.0.json').then(async response => {
                const schema = await response.json()
                console.debug(response)
                const session = enigma.create({
                  schema,
                  url: `wss://${this.TENANT}/app/${this.APPID}?${params}`
                });

                console.debug(session)
                const enigmaGlobal = await session.open();

                console.debug(enigmaGlobal)

                const enigmaApp = await enigmaGlobal.openDoc(this.APPID);

                console.debug(enigmaApp)

                const createAppProps = await enigmaApp.createSessionObject({
                  qInfo: {
                    qId: "AppPropsList",
                    qType: "AppPropsList"
                  },
                  qAppObjectListDef: {
                    qType: "appprops",
                    qData: {
                      theme: "/theme"
                    }
                  }
                });
                const appProps = await enigmaApp.getObject('AppPropsList');
                const appPropsLayout = await appProps.getLayout();
                const theme = appPropsLayout.qAppObjectList.qItems[0].qData.theme;

                fetch("https://hpc.eu.qlikcloud.com/single/?appid=3e088fdc-1c63-4334-810d-a00edc8f18ce&sheet=f9d79074-ac54-479f-9b66-7374c31fb363&opt=ctxmenu,currsele", {
                  method: "GET",
                  credentials: "include"
                })
                  .then(response => {console.debug(response)})
                  .catch(error => {
                    console.error("Fehler:", error.message);
                  });

                //const frameUrl = `https://${this.TENANT}/single/?appid=${this.APPID}&sheet=${this.SHEETID}&theme=${theme}&opt=ctxmenu,currsel`;
                //document.getElementById('qlik_frame').setAttribute('src', frameUrl);



              })
            })
          })


      })
    },
  },
};
</script>

<style scoped>
.text-color-white {
  color: white;
}
</style>